var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useEffect } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import analytics from '../../analytics';
import { GOOGLE_MAP_API_KEY, PRICELINE_MAP_ID } from '../../constants/googleMapConst';
import { createMapAdvancedMarkerElement } from './createMapAdvancedMarkerElement';
export const useGoogleMapsHooks = ({
  pinsOnMap
}) => {
  useEffect(() => {
    const pinKeys = Object.keys(pinsOnMap);
    if (pinKeys.length !== 0) {
      const loader = new Loader({
        apiKey: GOOGLE_MAP_API_KEY,
        version: 'weekly'
      });
      loader.importLibrary('maps').then(({
        Map
      }) => __awaiter(void 0, void 0, void 0, function* () {
        const gMap = new Map(document.getElementById('PENNY-SEARCH-GOOGLE-MAP'), {
          center: {
            lat: pinsOnMap[pinKeys[0]].lat,
            lng: pinsOnMap[pinKeys[0]].lng
          },
          zoom: 8,
          mapId: PRICELINE_MAP_ID // The priceline mapId
        });
        // Make the map is fully loaded before loading the marker
        const [{
          AdvancedMarkerElement
        }, {
          LatLngBounds
        }] = yield Promise.all([loader.importLibrary('marker'), loader.importLibrary('core')]);
        // The bounds of the map this will help set the center viewport based on pins
        const bounds = new LatLngBounds();
        pinKeys.forEach(key => {
          createMapAdvancedMarkerElement({
            gMap,
            AdvancedMarkerElement,
            bounds,
            pinDetails: pinsOnMap[key]
          });
        });
        // Run the fitBounds method to set the viewport based on the pins
        gMap.fitBounds(bounds);
      })).catch(error => {
        analytics.logError({
          loggedFrom: 'useGoogleMapsHooks',
          message: error === null || error === void 0 ? void 0 : error.message
        });
      });
    }
  }, []);
};